<div class="relative w-full min-h-screen us:mt-163px us-landscape:mt-117px md:mt-117px lg-landscape:mt-114px">
    <iframe *ngIf="show" class="absolute top-0 left-0 w-full h-full" [src]="link"
        frameborder="0"></iframe>
</div>